import { useEffect, useState } from "react";
import { State } from "../../../domain/model/ResponseState";
import { useSnackbar } from "notistack";
import { GetAllCategoriesUseCase } from "../../../domain/usecase/category/getAll/GetAllUseCase";
import {
  Category,
  convertCategoryEntityListToCategoryList,
} from "../../../domain/model/Category";
import {
  ResetQuestionsHistoryRequestDataModel,
  SubcategoriesToResetDataModel,
} from "../../../domain/model/User";
import { PlayerResetQuestionsUseCase } from "../../../domain/usecase/player/ResetQuestions/ResetQuestionsUseCase";
import { showGlobalLoadingView } from "../../../core/utils/Utils";

export function ResetQuestionsViewModel(
  getAllCategoriesUseCase: GetAllCategoriesUseCase,
  playerResetQuestionsUseCase: PlayerResetQuestionsUseCase
) {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [categories, setCategories] = useState<Array<Category>>([]);

  useEffect(() => {
    getCategories();
  }, []);

  async function getCategories() {
    setLoading(true);
    const response = await getAllCategoriesUseCase.invoke(true);
    switch (response.responseState) {
      case State.Success:
        if (response.data) {
          setCategories(convertCategoryEntityListToCategoryList(response.data));
        }
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  async function resetQuestions() {
    showGlobalLoadingView(true);
    const response = await playerResetQuestionsUseCase.invoke(
      getQuestionsToReset()
    );
    switch (response.responseState) {
      case State.Success:
        showSnackbar(response?.data?.message, "success");
        selectAll(false);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    showGlobalLoadingView(false);
  }

  function selectAll(bool?: boolean) {
    const newList = [...categories];
    newList.map((c) => {
      const newSubs = [...c.subcategories];
      newSubs.map((s) => {
        s.isSelected = bool ?? !c.isSelected;
      });
      c.subcategories = newSubs;
      c.isSelected = bool ?? !c.isSelected;
    });
    setCategories(newList);
  }

  function onCategoryClicked(categoryId: string) {
    const newList = [...categories];

    newList.map((c) => {
      if (c.id == categoryId) {
        const newSubs = [...c.subcategories];
        newSubs.map((s) => {
          s.isSelected = !c.isSelected;
        });
        c.subcategories = newSubs;
        c.isSelected = !c.isSelected;
      }
    });

    setCategories(newList);
  }

  function onSubcategoryClicked(categoryId: string, subcategoryName: string) {
    const newList = [...categories];

    newList.map((c) => {
      if (c.id == categoryId) {
        const newSubs = [...c.subcategories];
        newSubs.map((s) => {
          if (s.title == subcategoryName) s.isSelected = !s.isSelected;
        });
        c.subcategories = newSubs;
        c.isSelected =
          newSubs.filter((s) => s.isSelected).length == newSubs.length;
      }
    });

    setCategories(newList);
  }

  function getQuestionsToReset(): SubcategoriesToResetDataModel {
    const list: Array<ResetQuestionsHistoryRequestDataModel> = [];

    categories.map((c) => {
      const subcategories: Array<string> = c.subcategories
        .filter((s) => s.isSelected)
        .flatMap((s) => s.title);
      if (subcategories.length > 0) {
        list.push({
          categoryId: c.id,
          subcategories: subcategories,
        });
      }
    });
    return { subcategoriesToReset: list };
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    loading,
    categories,
    getQuestionsToReset,
    onCategoryClicked,
    onSubcategoryClicked,
    selectAll,
    resetQuestions,
  };
}
